import http from '../httpConfig';
import { Theme, Permissions } from '../interfaces/common';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { LOCAL_STORAGE_KEYS } from '../utils/appConstant';
import { encryptData, decryptData } from '../utils/methods';

const verifyTotp = (userId: number, code: string) =>
  http.post(API_ENDPOINTS.mfaVerifyTotp, { userId, code });

const sendOtp = (userId: number) =>
  http.post(API_ENDPOINTS.mfaSendOtp, { userId });

const verifyOtp = (userId: number, code: string) =>
  http.post(API_ENDPOINTS.mfaVerifyOtp, { userId, code });

const requestLoginOtp = (email: string) =>
  http.post(API_ENDPOINTS.otpRequest, { email });

const verifyLoginOtp = (email: string, code: string) =>
  http.post(API_ENDPOINTS.otpVerify, { email, code });

const storeLoggedInUser = (user: any) =>
  localStorage.setItem(LOCAL_STORAGE_KEYS.loggedInUser, encryptData(user));

const getLoggedInUser = () => {
  const data = localStorage.getItem(LOCAL_STORAGE_KEYS.loggedInUser);
  return data ? decryptData(data) : {};
};

const storeIsSystemAdmin = (isSystemAdmin: string | boolean) =>
  localStorage.setItem(LOCAL_STORAGE_KEYS.isSystemAdmin, encryptData(isSystemAdmin));

const getIsSystemAdmin = () => {
  const data = localStorage.getItem(LOCAL_STORAGE_KEYS.isSystemAdmin);
  return data && decryptData(data) ? decryptData(data) : '';
};

const storeLoading = (loading: string) =>
  localStorage.setItem(LOCAL_STORAGE_KEYS.loading, encryptData(loading));

const getLoading = () => {
  const data = localStorage.getItem(LOCAL_STORAGE_KEYS.loading);
  return data && decryptData(data) ? decryptData(data) : '';
};

const storeException = (exception: string) =>
  localStorage.setItem(LOCAL_STORAGE_KEYS.exception, encryptData(exception));

const getException = () => {
  const data = localStorage.getItem(LOCAL_STORAGE_KEYS.exception);
  return data && decryptData(data) ? decryptData(data) : '';
};

const storeToken = (token: string) =>
  localStorage.setItem(LOCAL_STORAGE_KEYS.token, encryptData(token));

const getToken = () => {
  const data = localStorage.getItem(LOCAL_STORAGE_KEYS.token);
  return data && decryptData(data) ? decryptData(data) : '';
};

const storeTheme = (theme: Theme) =>
  localStorage.setItem(LOCAL_STORAGE_KEYS.theme, encryptData(theme));

const getTheme = (): Theme => {
  const data = localStorage.getItem(LOCAL_STORAGE_KEYS.theme);
  return data && decryptData(data) ? decryptData(data) : 'light';
};

const storePermissions = (permissions: Permissions) =>
  localStorage.setItem(LOCAL_STORAGE_KEYS.permissions, encryptData(permissions));

const getPermissions = () => {
  const data = localStorage.getItem(LOCAL_STORAGE_KEYS.permissions);
  return data ? decryptData(data) : [];
};

const logout = async () => new Promise((resolve) => resolve(true));

const AuthService = {
  verifyTotp,
  sendOtp,
  verifyOtp,
  requestLoginOtp,
  verifyLoginOtp,
  getLoggedInUser,
  storeLoggedInUser,
  storeIsSystemAdmin,
  storeException,
  getIsSystemAdmin,
  getToken,
  storeToken,
  storePermissions,
  getPermissions,
  storeTheme,
  getTheme,
  getException,
  storeLoading,
  getLoading,
  logout,
};

export default AuthService;
